function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3CB09F",
  fillRule: "nonzero",
  d: "M19.649 9.86h1.012c.174 0 .316.141.316.316v8.362a.316.316 0 0 1-.316.316H19.65a.316.316 0 0 1-.316-.316v-8.362c0-.175.142-.316.316-.316zm-3.867 3.373h1.012c.175 0 .316.141.316.315v4.99a.316.316 0 0 1-.316.316h-1.012a.316.316 0 0 1-.315-.316v-4.99c0-.174.14-.315.315-.315zM11.916 9.86h1.012c.174 0 .315.141.315.316v8.362a.316.316 0 0 1-.315.316h-1.012a.316.316 0 0 1-.316-.316v-8.362c0-.175.141-.316.316-.316zm-3.867 3.373H9.06c.174 0 .316.141.316.315v4.99a.316.316 0 0 1-.316.316H8.05a.316.316 0 0 1-.316-.316v-4.99c0-.174.142-.315.316-.315z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  stroke: "#3CB09F",
  strokeWidth: 1.24
}));

const SvgIcCloudInsights = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 31 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloudInsights, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cloud-insights.fdcddf3a.svg";
export { ForwardRef as ReactComponent };